import React, { useMemo } from "react";
import Select, { components } from "react-select";

const BankTransfersMembershipMemberSelect = ({
    value,
    options = [],
    onChange,
    disabled = false
}) => {
    const selectOptions = useMemo(() => [
        {
            value: null,
            label: "Bez przypisania",
            isEmpty: true
        },
        ...[...options]
            .sort((a, b) => (a.name ?? "").localeCompare(b.name ?? "", "pl", { sensitivity: "base" }))
            .map((option) => ({
                value: option.id,
                label: option.name
            }))
    ], [options]);

    const selectedOption = useMemo(() => {
        if (value == null)
            return null;

        return selectOptions.find(
            (option) => option.value === value
        ) ?? null;
    }, [selectOptions, value]);

    const SingleValue = (props) => (
        <components.SingleValue {...props}>
            <span
                className="bank-transfer-trip-selected-value"
                title={props.data.label}
            >
                {props.data.label}
            </span>
        </components.SingleValue>
    );

    const Option = (props) => (
        <components.Option {...props}>
            <div
                className={
                    props.data.isEmpty
                        ? "bank-transfer-trip-select-option-empty"
                        : "bank-transfer-trip-select-option"
                }
            >
                {props.data.isEmpty && (
                    <span className="bank-transfer-trip-select-option-empty-icon">
                        ×
                    </span>
                )}

                <span>
                    {props.data.label}
                </span>
            </div>
        </components.Option>
    );

    const NoOptionsMessage = (props) => (
        <components.NoOptionsMessage {...props}>
            <div className="bank-transfer-trip-no-options">
                Nie znaleziono osoby
            </div>
        </components.NoOptionsMessage>
    );

    return (
        <div
            className="bank-transfer-trip-react-select"
            onClick={(e) => e.stopPropagation()}
        >
            <Select
                options={selectOptions}
                value={selectedOption}
                onChange={(option) =>
                    onChange(option?.value ?? null)
                }
                isSearchable
                isClearable={false}
                isDisabled={disabled}
                placeholder="+ Przypisz"
                noOptionsMessage={() => "Nie znaleziono osoby"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                components={{
                    SingleValue,
                    Option,
                    NoOptionsMessage,
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null
                }}
                classNamePrefix="bank-trip-select"
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                    })
                }}
            />
        </div>
    );
};

export default BankTransfersMembershipMemberSelect;